import { AxiosClient } from "./AxiosClient";

export const getAllApts = () => {
  try {
    return AxiosClient.get("threats/getAllApts", { useTarget: true });
  } catch (e) {
    console.log(e);
  }
};

export const getAptData = (apt) => {
  try {
    return AxiosClient.get("threats/getAptData?apt=" + apt);
  } catch (e) {
    console.log(e);
  }
};

export const getAptPosts = (apt) => {
  try {
    return AxiosClient.get("threats/getPostsByApt?apt=" + apt);
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const searchApts = ({ searchString, offset }) => {
  try {
    return AxiosClient.get(
      "threats/searchApts?search=" + searchString + "&offset=" + offset,
    );
  } catch (e) {
    console.log(e);
    return e;
  }
};
